
export const BaseURL = process.env.REACT_APP_URL // "http://localhost:3005/Usuarios/"//"http://localhost:3005/Usuarios/"//"http://localhost:3005/Usuarios/"//"http://localhost:3005/Usuarios/"////"http://localhost:3005/Usuarios/"////"http://localhost:3005/Usuarios/"//"https://10.0.1.30:443/Usuarios/";//////"https://52.67.137.250:443/Usuarios/" //"http://127.0.0.1:3000/Usuarios/"
export const getAllTransactions = "getTodasTransaccionesEmpresasPlink"
export const updatePasswordAdmin = "updatePassword"
export const addUserDPOS = "addUserDPOS"
export const sendMailAdmin = "sendMailAdmin"
export const getAllUserDPOS = "getAllUserDPOS"
export const addNewUserAdmin = "addNewUserAdmin"
export const loginApi = process.env.REACT_APP_LOGIN 
export const SumTrxApi = "sum_trx_plink"
export const MasterKeyLogin = process.env.REACT_APP_LOGIN_KEY
export const SumTrxDate = "sum_trx_to_date_plink"
export const getTransactionsByDate = "getTransaccionesFechaPlink"
export const getTrxMonth = "get_transacciones_mes_plink"
export const generateTokenIndividual = "generateLinkIndividualPlink"
